import { render, staticRenderFns } from "./WalletWithdrawInfo.vue?vue&type=template&id=fe472bc2&scoped=true&"
import script from "./WalletWithdrawInfo.vue?vue&type=script&lang=js&"
export * from "./WalletWithdrawInfo.vue?vue&type=script&lang=js&"
import style0 from "./WalletWithdrawInfo.vue?vue&type=style&index=0&id=fe472bc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe472bc2",
  null
  
)

export default component.exports